import React from "react"
import moment from "moment"
import { Panel } from "react-bootstrap"
import { get, find, isEqual, isBoolean, isArray, isObject, keys } from "lodash"

import { getPropTranslation, renderModification } from './LogTools.jsx'
import propsBlackList from "./propsBlackList"
import { getText, getTextWithTokens } from  '../lib/text'
import Change from './Change'

// #WARNING *maybe* should use getNameOrTitle or sthg?
function getDocumentName(doc) {
  return doc.name || doc.realName || `[sin nombre (${doc._id})]`
}

const LogEntry = ({
  entry,
  entryIdx,
  document,
  log,
  jsonDiffInstance,
  Activities,
  Cities
}) => {
  if (entry.type == "c") return (
    <Panel style={{ paddingLeft: "15px" }}>
      <Panel.Body>
        <li><b>{entry.username}</b> ({moment(entry.timestamp).format("HH:mm")}): {getText("Creado")} {getText(entry.col)} {getDocumentName(document)}</li>
      </Panel.Body>
    </Panel>
  )

  else if (entry.type == "u") {
    const previous = find(
      log,
      e => e.col == entry.col && e.type == entry.type && e.id == entry.id,
      entryIdx + 1
    )

    return (
      <Panel style={{ paddingLeft: "15px" }}>
        <Panel.Body>
          <li>
            <b>{entry.username}</b> ({moment(entry.timestamp).format("HH:mm")}): {getText("Modificado")} {getText(entry.col)} {getDocumentName(document)}:
            <ul>
              {
                keys(entry.changes)
                  .filter(propName => !propsBlackList[propName])
                  .map(propName => {
                    const change = entry.changes[propName]
                    if (isArray(change)) {
                      return (
                        <Change
                          entry={change}
                          previous={get(previous, ["changes", propName], [])}
                          propName={propName}
                          jsonDiffInstance={jsonDiffInstance}
                          Activities={Activities}
                          Cities={Cities}
                        />
                      )
                    }
                    else if (isObject(change) && !isArray(change) && keys(change).length > 0) {
                      return (
                        <Change
                          entry={[change]}
                          previous={[get(previous, ["changes", propName], {})]}
                          propName={propName}
                          jsonDiffInstance={jsonDiffInstance}
                          Activities={Activities}
                          Cities={Cities}
                        />
                      )
                    }
                    else if (!isEqual(change, previous && previous.changes[propName])) {
                      if ((!previous || !previous.changes[propName]) && !isBoolean(change)) {
                        return (
                          <li key={propName}>
                            {getTextWithTokens('$$ cambió a $$', [getPropTranslation(propName) ? getText(getPropTranslation(propName)) : propName, change])}
                          </li>
                        )
                      }
                      else if (change && previous && change != previous.changes[propName]) {
                        return renderModification(propName, change, previous.changes[propName])
                      }
                    }
                    return "Don't know how to render this entry..."
                  })
              }
            </ul>
          </li>
        </Panel.Body>
      </Panel>
    )
  }

  else return (
    <Panel>
      <Panel.Header>ERROR: No entiendo esta entrada</Panel.Header>
      <Panel.Body>
        <code>
          {JSON.stringify(entry)}
        </code>
      </Panel.Body>
    </Panel>
  )
}

export default LogEntry
